<template>
	<div class="content-page content-page--vendor-integration-details">
		<ActionSetNav
			:name="integrationData.name"
			:display="true"
			:actions="actions"
		/>
		<div class="content-page__heading">
			<div class="content-page__breadcrumb-title">
				<Breadcrumbs :items="urlNames" />
				<h2 class="content-page__title">
					3P Vendor Integration Details
				</h2>
			</div>
		</div>

		<Spinner :processor="{ loading: false }" />

		<div class="vendor-integration-details__content" v-if="true">
			<div class="vendor-integration-details__header">
				<div class="vendor-integration-details__header-primary">
					<div class="vendor-integration-details__header-status">
						<NotificationIcon
							:variant="notificationVariantIcon"
							@mouseenter="tooltipStatusVisible = true"
							@focus="tooltipStatusVisible = true"
							@mouseleave="tooltipStatusVisible = false"
							@blur="tooltipStatusVisible = false"
							ref="tooltipStatusRef"
						/>
						<!--TODO: text for tooltip-->
						<Tooltip
							:text="'Active'"
							:trackedRefName="'tooltipStatusRef'"
							:display="tooltipStatusVisible"
							position="top-start"
						/>
					</div>

					<div class="vendor-integration-details__header-group">
						<span class="vendor-integration-details__header-name">
							{{ integrationData.name }}
						</span>
						<div class="vendor-integration-details__header-txt">
							<span
								class="vendor-integration-details__header-alias"
								>{{ integrationData.alias }}</span
							>
							<span
								class="vendor-integration-details__header-separator"
								v-if="integrationData.alias"
								>|</span
							>
							<span
								class="vendor-integration-details__header-int-standard"
								>SecureVUE - Star Standard</span
							>
							<span
								class="vendor-integration-details__header-separator"
								>|</span
							>
							<span
								class="vendor-integration-details__header-int-id"
								>123654</span
							>
						</div>
						<div class="vendor-integration-details__header-tags">
							<TagLabel
								message="USES AUTHENTICOM"
								:state="'secondary-2'"
							/>
							<TagLabel message="INBOUND" />
						</div>
					</div>
				</div>

				<span class="vendor-integration-details__header-toggle"
					><Toggle
						:label="integrationData.active ? 'Active' : 'Inactive'"
						:value="integrationData.active"
						@change="() => {}"
				/></span>
			</div>

			<SectionContainer class="vendor-integration-details__main-content">
				<template #left>
					<span class="vendor-integration-details__main-content-title"
						>Integration Details</span
					>
				</template>
				<template #right>
					<Button
						className="btn btn--has-icon btn--small"
						iconClassName="icon-edit"
						labelText="Edit Details"
						:btnClick="editDetails"
						:iconBeforeLabel="true"
						v-if="hasUpdatePermission"
					/>
				</template>

				<template #content>
					<div
						class="vendor-integration-details__main-content-details"
					>
						<div
							class="vendor-integration-details__main-content-details-group"
						>
							<ReadonlyField
								label="Integration Name"
								:text="integrationData.name"
							/>
							<ReadonlyField
								label="Alias Name"
								:text="integrationData.alias"
							/>
							<ReadonlyField
								label="Vendor Name"
								:text="integrationData.vendorName"
							/>
							<ReadonlyField label="DMS-IS" text="Authenticom" />
							<ReadonlyField
								label="Integration Type"
								:text="integrationData.integrationType"
							/>
							<ReadonlyField :label="`APIs`">
								<template #subContent
									><span
										class="vendor-integration-details__field-action"
										><Button
											className="btn btn--inline-link"
											:labelText="
												`View APIs (${apiCount})`
											"
											:btnClick="
												() => {
													displayApisModal = true;
												}
											"
											:iconBeforeLabel="true"
											v-if="apiCount"/></span
								></template>
							</ReadonlyField>
							<!--TODO: Dev Review. Username and Password should be able to Show/hide content.-->
							<ReadonlyField
								label="Username"
								:text="integrationData.username"
							/>
							<ReadonlyField
								label="Password"
								:text="handlingPasswordValue"
							/>
						</div>

						<div
							class="vendor-integration-details__main-content-details-group"
						>
							<ReadonlyField
								v-if="employeeName"
								label="Global Employee"
								:text="employeeName"
								:textIconInfo="globalEmployeeMessage"
							/>
							<ReadonlyField
								label="Category of Service"
								:text="integrationData.essentialCategory"
							/>
							<ReadonlyField
								label="Direction"
								:text="integrationData.direction"
								:textIconInfo="directionMessage"
							/>
							<!--TODO: Dev Review -->
							<ReadonlyField
								label="Module Category"
								:text="integrationData.moduleCategories"
							/>
							<ReadonlyField
								label="Hardware"
								:text="integrationData.hardware ? 'Yes' : 'No'"
							>
								<template
									#subContent
									v-if="integrationData.hardware"
									><span
										class="vendor-integration-details__field-action"
										><Button
											className="btn btn--inline-link"
											:labelText="`View Hardware Specs`"
											:btnClick="
												() => {
													displaySpecificationModal = true;
													specificationTitle =
														'Hardware - Hardware Specification';
													specificationContentText =
														integrationData.hardware;
												}
											"
											:iconBeforeLabel="
												true
											"/></span></template
							></ReadonlyField>
							<ReadonlyField
								label="Additional Setups"
								:text="integrationData.setup ? 'Yes' : 'No'"
							>
								<template
									#subContent
									v-if="integrationData.setup"
									><span
										class="vendor-integration-details__field-action"
										><Button
											className="btn btn--inline-link"
											:labelText="`View Setup Specs`"
											:btnClick="
												() => {
													displaySpecificationModal = true;
													specificationTitle =
														'Additional Setups - Setup Specification';
													specificationContentText =
														integrationData.setup;
												}
											"
											:iconBeforeLabel="
												true
											"/></span></template
							></ReadonlyField>
							<ReadonlyField
								label="Additional Features"
								:text="integrationData.feature ? 'Yes' : 'No'"
							>
								<template
									#subContent
									v-if="integrationData.feature"
									><span
										class="vendor-integration-details__field-action"
										><Button
											className="btn btn--inline-link"
											:labelText="`View Feature Specs`"
											:btnClick="
												() => {
													displaySpecificationModal = true;
													specificationTitle =
														'Additional Features - Features Specification';
													specificationContentText =
														integrationData.feature;
												}
											"
											:iconBeforeLabel="
												true
											"/></span></template
							></ReadonlyField>
						</div>

						<div
							class="vendor-integration-details__main-content-details-group"
						>
							<ReadonlyField
								label="Internal Notes"
								:text="
									integrationData.internalNotes +
										' Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec qu'
								"
							/>
							<ReadonlyField
								label="3P Vendor Integration Description"
								:text="
									integrationData.description +
										' Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibu'
								"
							/>
						</div>
					</div>
				</template>
			</SectionContainer>
		</div>
		<VendorIntegrationDetailsFlyout
			:integration="integrationData"
			v-model="displayDetails"
		/>
		<ApisModal
			:display="displayApisModal"
			:integration="integration"
			@close="() => (displayApisModal = false)"
		/>
		<VendorIntegrationSpecificationModal
			:title="specificationTitle"
			:contentText="specificationContentText"
			v-model="displaySpecificationModal"
			@show="closeSpecificationModal"
		/>
	</div>
</template>

<script>
import ActionSetNav from '@/site-components/actions-set/action-set-nav';
import Breadcrumbs from '@/components/shells/breadcrumbs/breadcrumbs';
import Button from '@/components/forms/button/button';
import SectionContainer from '@/components/shells/section-container/section-container';
import ReadonlyField from '@/components/forms/readonly-field/readonly-field';
import Spinner from '@/components/visual/spinner/spinner';
import Toggle from '@/components/forms/selection-control/toggle/toggle';
import VendorIntegrationDetailsFlyout from './vendor-integration-details-flyout';
import NotificationIcon from '@/components/notifications/notification-icon/notification-icon';
import TagLabel from '@/components/visual/tag-label';
import Tooltip from '@/components/shells/tooltip/tooltip';
import DatetimeMixin from '@/mixins/datetime-mixin';
import { mapActions, mapGetters } from 'vuex';
import ApisModal from '@/sections/vendors/apis/apis-modal';
import VendorIntegrationSpecificationModal from './vendor-integration-specification-modal.vue';
import {
	MODULE_NAME,
	SET_INTEGRATION,
	INTEGRATION,
	ERROR,
	LOADING
} from '../integrations-mutation-types';

import _ from 'lodash';
import pageKeyNames from '@/utils/page-key-names';

export default {
	name: 'VendorsIntegrationSettings',
	mixins: [DatetimeMixin],
	components: {
		ActionSetNav,
		Breadcrumbs,
		Button,
		SectionContainer,
		ReadonlyField,
		Spinner,
		TagLabel,
		Toggle,
		VendorIntegrationDetailsFlyout,
		NotificationIcon,
		Tooltip,
		VendorIntegrationSpecificationModal,
		ApisModal
	},
	props: {
		id: {
			type: Number,
			required: true
		},
		integratorId: {
			type: Number,
			required: true
		},
		integratorName: {
			type: String
		}
	},
	async created() {
		if (this.id) {
			await this.getIntegrationVendorById();
			this.actions = [
				{
					id: 1,
					disabled: false,
					iconClass: 'icon icon-document',
					label: 'Details',
					title: 'Select to go to vendors settings',
					type: 'route-link',
					visible: true
				},
				{
					id: 2,
					action: () => (this.showCustomerModal = true),
					title: 'Select to go to clients',
					iconClass: 'icon icon-company',
					label: 'CCL',
					type: 'anchor',
					visible: true,
					disabled: !this.integrationData.customersCount,
					valueBadgeCount: this.integrationData.customersCount
				},
				{
					id: 3,
					//TODO: Add back in when integrations is ready
					// action: this.showModal,
					title: 'Select to go to APIs',
					iconClass: 'icon icon-apis',
					label: 'APIs',
					type: 'route-link',
					visible: true,
					disabled: true,
					valueBadgeCount: this.integrationData.integrationsCount
				},
				{
					id: 4,
					action: '#',
					disabled: false,
					iconClass: 'icon icon-menu',
					label: '',
					title: 'select to see the more actions',
					type: 'dropdown',
					visible: true,
					items: [
						{
							id: 5,
							action: {
								path: `/vendors/history/${
									this.integrationData.id
								}/${encodeURIComponent(
									this.integrationData.integratorName
								)}`
							},
							iconClass: 'icon icon-history',
							label: 'History',
							title: 'Select to go to vendors history',
							type: 'route-link',
							visible: true,
							disabled: true
						}
					]
				}
			];
		}
	},
	mounted() {
		this.$store.commit('setCurrentPage', pageKeyNames.VENDOR_SETTINGS);
	},
	destroyed() {
		this.$store.commit('setCurrentPage', null);
	},
	data() {
		return {
			actions: [],
			displayDetails: false,
			integrationData: {},
			tooltipStatusVisible: false,
			displayApisModal: false,
			displaySpecificationModal: false,
			specificationTitle: '',
			specificationContentText: '',
			directionMessage: 'Direction cannot be edited.',
			globalEmployeeMessage:
				'The Vendor and Integration Name can be viewed by DMS users if the integration is responsible for creating or editing information in VUE.'
		};
	},
	computed: {
		...mapGetters(MODULE_NAME, [INTEGRATION]),

		urlNames() {
			let breadcrumbs = _.get(
				this,
				'$route.meta.breadcrumb',
				this.$store.getters.breadcrumbs(this.$route.path)
			);
			if (
				breadcrumbs.length > 0 &&
				breadcrumbs[breadcrumbs.length - 1].name !==
					'3P Vendor Integration Details'
			) {
				breadcrumbs.push({ name: '3P Vendor Integration Details' });
			}
			return breadcrumbs;
		},
		vendorName() {
			return this.integrationData.name || '';
		},
		hasUpdatePermission() {
			return (
				this.validatePermission('vendors.update') &&
				this.integrationData.active !== null
			);
		},
		disabledActiveDeactivate() {
			return !this.integrationData.active;
		},
		isIntegrationSolution() {
			return _.get(this, 'integrationData.isAggregator', false);
		},
		vendorStatus() {
			if (this.integrationData.active === null) {
				return 'Transaction Error';
			}
			if (!this.integrationData.active) {
				return 'Inactive Vendor';
			}
			return 'Active Vendor';
		},
		notificationVariantIcon() {
			// TODO: review the status of integrations
			if (this.integrationData.status === null) {
				return 'not-allowed';
			}
			if (this.integrationData.status === 'Inactive') {
				return 'inactive';
			}
			return 'positive';
		},
		showDeactivateToggle() {
			return (
				this.hasUpdatePermission && this.integrationData.active !== null
			);
		},
		confluenceLinkAttrs() {
			if (this.integrationData.confluenceLink) {
				return {
					href: this.integrationData.confluenceLink,
					target: '_blank'
				};
			}
			return {};
		},

		handlingPasswordValue() {
			if (this.hasOnlyReadPermission) {
				return '***************************';
			}
			const { userPassword } = this.integrationData || '';
			return userPassword;
		},

		isMobile() {
			return this.screenSize.mobile;
		},
		variation() {
			if (this.isMobile) return 'top';
			return 'left';
		},
		maxLengthOnPasswordValue() {
			if (this.isMobile) return 10;
			return null;
		},
		isLoading() {
			return this[LOADING];
		},
		apiCount() {
			return _.size(this.integrationData.apis);
		},
		employeeName() {
			return (
				this.integrationData.employeeFirstName +
					' ' +
					this.integrationData.employeeLastName || ''
			);
		}
	},
	methods: {
		...mapActions(MODULE_NAME, {
			getIntegrationById: SET_INTEGRATION
		}),
		async getIntegrationVendorById() {
			await this.getIntegrationById({
				id: this.id,
				integratorId: this.integratorId
			});
		},
		editDetails() {
			this.displayDetails = true;
		},

		redirectToSummaryPage() {
			this.$router.push({
				path: '/vendors'
			});
		},
		cancelRemoveVendor() {
			this.showConfirmationDeleteModal = false;
		},

		handlingError(messageObj) {
			this.$store.dispatch('toastMessages/show', {
				toastId: 'vendor.action',
				statusCode: messageObj.status,
				message: messageObj.message,
				slot: 'default'
			});
		},
		closeSpecificationModal() {
			this.displaySpecificationModal = false;
		}
	},
	watch: {
		[ERROR]: {
			handler(val) {
				let message = {
					status: 400,
					message: val ? val : 'Integrator not found.'
				};
				this.handlingError(message);
				this.redirectToSummaryPage();
			}
		},
		[INTEGRATION]: {
			deep: true,
			async handler(val) {
				this.integrationData = _.cloneDeep(val);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
/**
  * 3P Vendor Integration Details
  * Can use SCSS variables = TRUE
**/

.vendor-integration-details {
	&__content {
		display: flex;
		flex-direction: column;
		background: $white;
		padding: $padding-lg $padding-lg $padding-lg $padding-md;
		border: 1px solid $neutral-3;
		border-radius: $form-border-radius;
	}

	&__header {
		display: grid;
		grid-template-columns: 1fr auto;
		column-gap: $gutter-xl;

		&-primary {
			display: grid;
			grid-template-columns: auto 1fr;
			column-gap: $gutter-md;
		}

		&-group {
			display: flex;
			flex-direction: column;
		}

		&-name {
			@include heading('md');
		}

		&-txt {
			display: flex;
			flex-direction: row;
			gap: $gutter-md;
			margin-top: $gutter-sm;
			@include body-text('regular');
		}

		&-separator {
			line-height: 0.93;
		}

		&-tags {
			display: flex;
			flex-direction: row;
			gap: $gutter-md;
			margin-top: $gutter-lg;
		}
	}

	&__main-content {
		margin-top: $gutter-xl;
	}

	&__main-content-title {
		@include body-text('regular-emphasis');
	}

	&__main-content-details {
		display: grid;
		grid-template-columns: 40fr 60fr;
		gap: $gutter-xl;

		@include mq($from: md-l) {
			grid-template-columns: 25fr 35fr 40fr;
		}
	}

	&__main-content-details-group {
		&:nth-child(3) {
			::v-deep .readonly-field {
				grid-template-columns: 1fr;
				row-gap: $gutter-lg;

				&:not(:last-child) {
					margin-bottom: $gutter-xl;
				}
			}

			@include mq($until: md-l) {
				grid-column: 1 / 3;
			}
		}
	}
}
</style>
